import PresortDemo from "../components/table/DataTable";
import { useRef, useState } from "react";
import {
	useGetUsersQuery,
	useCreateUserMutation,
	useSendUserWhatsappMutation
} from "../store/api/userAPI";
import { useUpdateUserPackagesMutation } from "../store/api/orderAPI";
import { Sidebar } from "primereact/sidebar";
import { userColumn } from "../metadata/user";
import "./page.css";
import Editor from "../components/UI/editor";
import { SpeedDial } from "primereact/speeddial";
import { useActionsHook } from "../hooks/useActionsHook";
import MyButton from "../components/UI/Button";
import { Toast } from "primereact/toast";
import { t } from "i18next";

import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { useNavigate } from "react-router";

function User() {
	const [sendMessageWhatsapp] = useSendUserWhatsappMutation();
	const [updateUserPackages, { isLoading: packageLoading }] = useUpdateUserPackagesMutation();
	const toast = useRef(null);

	const [selectedProducts, setSelectedProducts] = useState(null);
	const [createUser] = useCreateUserMutation();
	const [formData, setFormData] = useState({});
	const navigate = useNavigate();
	const [searchForm, setSearchForm] = useState({});
	const scanEditor = useRef({});
	const [visibleLeft, setVisibleLeft] = useState({ visible: false, data: null });

	const { data, error, isLoading, refetch } = useGetUsersQuery({
		search: searchForm?.email
	});

	const [messageDialogVisible, setMessageDialogVisible] = useState(false);
	const [messageText, setMessageText] = useState("");

	const [packageDialog, setPackageDialog] = useState({
		visible: false,
		user: null,
		package_shoes: 0,
		bag_package: 0,
	});

	const openPackageDialog = (user) => {
		setPackageDialog({
			visible: true,
			user,
			package_shoes: Number(user?.package_shoes ?? 0),
			bag_package: Number(user?.bag_package ?? 0),
		});
	};

	const closePackageDialog = () => {
		setPackageDialog({
			visible: false,
			user: null,
			package_shoes: 0,
			bag_package: 0,
		});
	};

	const actions = useActionsHook([
		{
			onClick: (e, params) => {
				navigate("/user-detail", {
					state: {
						clientCode: params.guid,
						...params
					}
				});
			},
			icon: "pi pi-eye"
		},
		{
			onClick: (e, params) => {
				openPackageDialog(params);
			},
			icon: "pi pi-box"
		}
	]);

	function toggleSidebar(bool, data = {}) {
		setFormData(data || {});
		setVisibleLeft({ visible: bool, data: data || {} });
	}

	const onBlur = (e, attr, value) => {
		setFormData((state) => ({ ...state, [attr]: value }));
	};

	const onSearchBlur = (e, attr, value) => {
		setSearchForm((state) => ({ ...state, [attr]: value }));
	};

	const handleSendMessage = async () => {
		if (!messageText.trim()) return;

		try {
			await sendMessageWhatsapp({ users: selectedProducts, message: messageText }).unwrap();
			toast.current.show({
				severity: "success",
				summary: "Success",
				detail: "Message sent successfully",
			});
			setMessageDialogVisible(false);
			setMessageText("");
		} catch (error) {
			console.error(error);
			toast.current.show({
				severity: "error",
				summary: "Error",
				detail: "Message sending failed",
			});
		}
	};

	const handleSavePackages = async () => {
		try {
			await updateUserPackages({
				guid: packageDialog.user?.guid,
				package_shoes: Number(packageDialog.package_shoes),
				bag_package: Number(packageDialog.bag_package),
			}).unwrap();

			toast.current.show({
				severity: "success",
				summary: "Успешно",
				detail: "Правила переупаковки сохранены",
			});

			closePackageDialog();
			refetch();
		} catch (error) {
			console.error(error);
			toast.current.show({
				severity: "error",
				summary: "Ошибка",
				detail: error?.data?.message || "Не удалось сохранить правила переупаковки",
			});
		}
	};

	return (
		<>
			<Toast ref={toast} />

			<div style={{ width: "360px", padding: "8px" }}>
				<Editor
					onBlur={onSearchBlur}
					data={searchForm}
					attr="email"
					placeholder="Поиск по email, номер, фио"
					trim
					refEl={scanEditor}
				/>
			</div>

			<SpeedDial
				model={[
					{
						label: "Сообщения",
						icon: "pi pi-comments",
						command: () => setMessageDialogVisible(true),
					},
					{
						label: "Меню",
						icon: "pi pi-plus",
						command: () => toggleSidebar(true, {}),
					},
				]}
				radius={80}
				type="quarter-circle"
				direction="up-left"
				style={{ right: 25, bottom: 25 }}
				buttonClassName="p-button-rounded p-button-info"
				showIcon="pi pi-bars"
				hideIcon="pi pi-times"
			/>

			<PresortDemo
				selection={selectedProducts}
				selectionMode="multiple"
				onSelectionChange={(e) => setSelectedProducts(e.value)}
				isLoading={isLoading}
				data={data?.data || []}
				paginator={true}
				scrollHeight="calc(100vh - 160px)"
				column={userColumn ?? (data?.data?.[0] ? Object.keys(data.data[0]) : [])}
				toggleSidebar={toggleSidebar}
				actions={actions}
			/>

			<Sidebar
				visible={visibleLeft.visible}
				position="right"
				onHide={() => toggleSidebar(false, {})}
				style={{ width: "50vw" }}
			>
				<div className="user-sidebar">
					<div className="user-sidebar-edit">
						{userColumn
							.filter((el) => el.editor)
							.map((el) => (
								<Editor
									key={el.field}
									{...el}
									onBlur={onBlur}
									data={formData}
								/>
							))}

						<MyButton
							label={t("save")}
							onClick={async () => {
								try {
									await createUser(formData).unwrap();
									toast.current.show({
										severity: "success",
										summary: "Success",
										detail: t("successSaved"),
									});
									setFormData({});
									setVisibleLeft({ visible: false, data: {} });
									refetch();
								} catch (error) {
									console.error(error);
									toast.current.show({
										severity: "error",
										summary: "Ошибка",
										detail: "Ошибка сохранения",
									});
								}
							}}
						/>
					</div>
				</div>
			</Sidebar>

			<Dialog
				header="Введите сообщение"
				visible={messageDialogVisible}
				onHide={() => setMessageDialogVisible(false)}
				style={{ width: "30vw" }}
			>
				<InputTextarea
					value={messageText}
					onChange={(e) => setMessageText(e.target.value)}
					rows={5}
					autoResize
				/>
				<div className="p-d-flex p-jc-end" style={{ marginTop: "12px", display: "flex", gap: "8px" }}>
					<Button label="Отправить" onClick={handleSendMessage} className="p-mr-2" />
					<Button label="Отмена" onClick={() => setMessageDialogVisible(false)} className="p-button-secondary" />
				</div>
			</Dialog>

			<Dialog
				header="Правила переупаковки"
				visible={packageDialog.visible}
				onHide={closePackageDialog}
				style={{ width: "520px", maxWidth: "95vw" }}
			>
				<div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
					<div
						style={{
							padding: "12px",
							borderRadius: "10px",
							background: "#f8f9fa",
							border: "1px solid #e5e7eb"
						}}
					>
						<div style={{ fontWeight: 700, marginBottom: "6px" }}>
							{packageDialog.user?.first_name || ""} {packageDialog.user?.last_name || ""}
						</div>
						<div style={{ color: "#6b7280", fontSize: "14px" }}>
							{packageDialog.user?.email || packageDialog.user?.phone || ""}
						</div>
					</div>

					<div>
						<div style={{ fontWeight: 600, marginBottom: "10px" }}>Обувь</div>
						<div style={{ marginBottom: "8px", color: "#6b7280", fontSize: "14px" }}>
							Сейчас: {Number(packageDialog.package_shoes) === 0 ? "Переупаковать" : "Оставить как есть"}
						</div>

						<div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
							<button
								type="button"
								onClick={() =>
									setPackageDialog((prev) => ({ ...prev, package_shoes: 0 }))
								}
								style={{
									padding: "12px 16px",
									borderRadius: "10px",
									border: Number(packageDialog.package_shoes) === 0 ? "2px solid #103D64" : "1px solid #d1d5db",
									background: Number(packageDialog.package_shoes) === 0 ? "#EEF6FD" : "#fff",
									cursor: "pointer",
									flex: 1,
									minWidth: "180px",
									textAlign: "left"
								}}
							>
								<div style={{ fontWeight: 600 }}>Переупаковать</div>
								<div style={{ fontSize: "13px", color: "#6b7280", marginTop: "4px" }}>
									Уменьшить объёмный вес
								</div>
							</button>

							<button
								type="button"
								onClick={() =>
									setPackageDialog((prev) => ({ ...prev, package_shoes: 1 }))
								}
								style={{
									padding: "12px 16px",
									borderRadius: "10px",
									border: Number(packageDialog.package_shoes) === 1 ? "2px solid #103D64" : "1px solid #d1d5db",
									background: Number(packageDialog.package_shoes) === 1 ? "#EEF6FD" : "#fff",
									cursor: "pointer",
									flex: 1,
									minWidth: "180px",
									textAlign: "left"
								}}
							>
								<div style={{ fontWeight: 600 }}>Оставить как есть</div>
								<div style={{ fontSize: "13px", color: "#6b7280", marginTop: "4px" }}>
									Без переупаковки
								</div>
							</button>
						</div>
					</div>

					<div>
						<div style={{ fontWeight: 600, marginBottom: "10px" }}>Сумки / рюкзаки</div>
						<div style={{ marginBottom: "8px", color: "#6b7280", fontSize: "14px" }}>
							Сейчас: {Number(packageDialog.bag_package) === 0 ? "Переупаковать" : "Оставить как есть"}
						</div>

						<div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
							<button
								type="button"
								onClick={() =>
									setPackageDialog((prev) => ({ ...prev, bag_package: 0 }))
								}
								style={{
									padding: "12px 16px",
									borderRadius: "10px",
									border: Number(packageDialog.bag_package) === 0 ? "2px solid #103D64" : "1px solid #d1d5db",
									background: Number(packageDialog.bag_package) === 0 ? "#EEF6FD" : "#fff",
									cursor: "pointer",
									flex: 1,
									minWidth: "180px",
									textAlign: "left"
								}}
							>
								<div style={{ fontWeight: 600 }}>Переупаковать</div>
								<div style={{ fontSize: "13px", color: "#6b7280", marginTop: "4px" }}>
									Уменьшить объёмный вес
								</div>
							</button>

							<button
								type="button"
								onClick={() =>
									setPackageDialog((prev) => ({ ...prev, bag_package: 1 }))
								}
								style={{
									padding: "12px 16px",
									borderRadius: "10px",
									border: Number(packageDialog.bag_package) === 1 ? "2px solid #103D64" : "1px solid #d1d5db",
									background: Number(packageDialog.bag_package) === 1 ? "#EEF6FD" : "#fff",
									cursor: "pointer",
									flex: 1,
									minWidth: "180px",
									textAlign: "left"
								}}
							>
								<div style={{ fontWeight: 600 }}>Оставить как есть</div>
								<div style={{ fontSize: "13px", color: "#6b7280", marginTop: "4px" }}>
									Без переупаковки
								</div>
							</button>
						</div>
					</div>

					<div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "10px" }}>
						<Button
							label="Отмена"
							className="p-button-secondary"
							onClick={closePackageDialog}
						/>
						<Button
							label={packageLoading ? "Сохранение..." : "Сохранить"}
							onClick={handleSavePackages}
							loading={packageLoading}
						/>
					</div>
				</div>
			</Dialog>
		</>
	);
}

export default User;